// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 16px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.toolbar-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toolbar-left {
  flex: 1;
}

.toolbar-center {
  flex: 0 0 auto;
}

.toolbar-right {
  flex: 1;
  justify-content: flex-end;
}

.toolbar-filename {
  font-size: 14px;
  color: #333;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.toolbar-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  color: #555;
  transition: all 0.15s ease;
}

.toolbar-btn:hover:not(:disabled) {
  background: #f0f0f0;
  color: #333;
}

.toolbar-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.toolbar-btn svg {
  flex-shrink: 0;
}

.toolbar-btn-primary {
  background: #0066cc;
  color: white;
  padding: 8px 16px;
}

.toolbar-btn-primary:hover:not(:disabled) {
  background: #0052a3;
  color: white;
}

.toolbar-divider {
  width: 1px;
  height: 24px;
  background: #e0e0e0;
  margin: 0 8px;
}

.page-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.page-input {
  width: 50px;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
}

.page-input:focus {
  outline: none;
  border-color: #0066cc;
}

/* Hide number input spinners */
.page-input::-webkit-inner-spin-button,
.page-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.page-input[type='number'] {
  -moz-appearance: textfield;
}

.zoom-indicator {
  min-width: 50px;
  text-align: center;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
}

.zoom-indicator:hover {
  background: #f0f0f0;
}

.edit-count {
  font-size: 12px;
  color: #666;
  background: #f0f0f0;
  padding: 4px 8px;
  border-radius: 10px;
}

.toolbar-info-btn {
  margin-left: 4px;
  color: #0066cc;
}

.toolbar-info-btn:hover {
  background: #e6f2ff;
  color: #0052a3;
}

`, "",{"version":3,"sources":["webpack://./src/ui/components/Toolbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  height: 56px;\r\n  padding: 0 16px;\r\n  background: #fff;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.toolbar-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.toolbar-left {\r\n  flex: 1;\r\n}\r\n\r\n.toolbar-center {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.toolbar-right {\r\n  flex: 1;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.toolbar-filename {\r\n  font-size: 14px;\r\n  color: #333;\r\n  max-width: 200px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.toolbar-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n  border: none;\r\n  background: transparent;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  color: #555;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.toolbar-btn:hover:not(:disabled) {\r\n  background: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.toolbar-btn:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.toolbar-btn svg {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.toolbar-btn-primary {\r\n  background: #0066cc;\r\n  color: white;\r\n  padding: 8px 16px;\r\n}\r\n\r\n.toolbar-btn-primary:hover:not(:disabled) {\r\n  background: #0052a3;\r\n  color: white;\r\n}\r\n\r\n.toolbar-divider {\r\n  width: 1px;\r\n  height: 24px;\r\n  background: #e0e0e0;\r\n  margin: 0 8px;\r\n}\r\n\r\n.page-indicator {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.page-input {\r\n  width: 50px;\r\n  padding: 4px 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.page-input:focus {\r\n  outline: none;\r\n  border-color: #0066cc;\r\n}\r\n\r\n/* Hide number input spinners */\r\n.page-input::-webkit-inner-spin-button,\r\n.page-input::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n.page-input[type='number'] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n.zoom-indicator {\r\n  min-width: 50px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  color: #666;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.zoom-indicator:hover {\r\n  background: #f0f0f0;\r\n}\r\n\r\n.edit-count {\r\n  font-size: 12px;\r\n  color: #666;\r\n  background: #f0f0f0;\r\n  padding: 4px 8px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.toolbar-info-btn {\r\n  margin-left: 4px;\r\n  color: #0066cc;\r\n}\r\n\r\n.toolbar-info-btn:hover {\r\n  background: #e6f2ff;\r\n  color: #0052a3;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
